"use client";

import { showNotification } from "@mads/util-web";
import { errorPageContent } from "@/constants/errorPageContent";
import { useRouter, useSearchParams } from "next/navigation";
import { normalizeLocale } from "@/utils/localeUtil";

export const useErrorToast = () => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const languageCode = normalizeLocale(searchParams?.get("locale"));
  const pageContent = errorPageContent[languageCode];

  return () => {
    showNotification({
      header: pageContent.somethingWentWrong,
      status: "error",
      message: pageContent.pleaseTryAgainLater,
    });
    router.push("/not-found");
  };
};
